import type { Theme } from '@mui/material';

export const styles = {
  wrapper: {
    justifyContent: 'space-between',
    flexGrow: 1,
    maxWidth: '100%',
    height: '100%',
  },

  headline: (theme: Theme) => ({
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '1.25rem',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    marginBottom: theme.spacing(1),

    [theme.breakpoints.up('lg')]: {
      fontSize: 18,
      lineHeight: '1.325em',
    },
  }),

  doughnutWidgetContent: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
  },

  label: {
    fontWeight: 500,
    fontSize: 14,
    justifyContent: 'center',
  },

  labelText: {
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
  },

  percentage: (theme: Theme) => ({
    color: theme.colors.neutral[600],
  }),

  chart: {
    width: '14rem',
    height: '14rem',
  },
};
